<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 md10 lg6>
        <barcode
          :title="step"
          returnTo="/repairs"
          subtitle="Scan or Enter a Serial Number"
          buttonText="Complete Step"
          @search="searchRepairs"
          @cleared="handleCleared"
          @extraAction="goBack"
          ref="barcodeComponent"
          extraButtonText="Go Back"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Barcode from "@/components/app/Barcode";

export default {
  name: "step",
  data() {
    return {};
  },

  components: {
    Barcode,
  },

  mixins: [LoginCheck],

  computed: {
    ...mapGetters({
      repair: "repair/getRepair",
      repairOperations: "repair/getRepairOperations",
    }),

    step() {
      let step = this.$route.params.step;

      switch (step.toLowerCase()) {
        case "pre-cleaning":
          return "Pre-Cleaning";
        case "cleaning":
          return "Post-Cleaning";
        case "testing":
          return "Testing";
        case "polishing":
          return "Polishing";
        default:
          return "";
      }
    },
  },

  destroyed() {
    this.$store.commit("repair/setRepair", []);
  },

  methods: {
    ...mapActions({
      repairSearch: "repair/searchServices",
      addOperation: "repair/addOperation",
      getOperation: "repair/getRepairOperations",
      updateOperation: "repair/updateOperation",
    }),
    async searchRepairs(barcodeValue) {
      await this.repairSearch({ serial: barcodeValue.trim() });
      if (!this.repair.length) {
        this.$store.dispatch("app/setSnackbar", {
          text: `Repair Not Found`,
          color: "error",
        });
        this.handleCleared();
        return;
      }
   
      await this.addOperation({
        repairID: this.repair[0].id,
        step: this.step,
      });
   
      this.$store.dispatch("app/setSnackbar", {
        text: `${this.step} Step Added!`,
        color: "green",
      });
      this.handleCleared();
    },

    handleCleared() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$refs.barcodeComponent.focusBarcode();
      this.$store.commit("repair/setRepair", []);
    },
    goBack() {
      this.$router.push("/repairs");
    },
  },
};
</script>

<style>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
